export default __webpack_public_path__ + "static/media/Scholar's Belt of the Burning Disc.69135672.jpg";